import { useState, useEffect } from "react";
import SelectMistakePopUp from "./SelectMistakePopUp";

const SessionText = ({
  session,
  miscueList,
  sessionAssessment,
  editionMode = false,
  isEdit,
  localBehaviors,
  onApplyBehavior,
  hideTitle = false,
}) => {
  const [behaviors, setBehaviors] = useState([]);
  const [dialog, setDialog] = useState({
    open: false,
    wordIndex: null,
    currentMistakeId: null,
  });

  const canEdit = isEdit ?? editionMode;

  useEffect(() => {
    setBehaviors(localBehaviors || session?.reading?.behaviors || []);
  }, [session, localBehaviors]);

  const handleWordClick = (wordIndex, currentMistakeId) => {
    setDialog({ open: true, wordIndex, currentMistakeId });
  };

  const handleCloseDialog = () => {
    setDialog({ open: false, wordIndex: null, currentMistakeId: null });
  };

  const handleMistakeSelect = (mistake) => {
    if (onApplyBehavior) {
      onApplyBehavior(dialog.wordIndex, mistake?.id || null);
    }
    setBehaviors((prev) => {
      const without = prev.filter((b) => b.index !== dialog.wordIndex);
      return mistake
        ? [...without, { index: dialog.wordIndex, behavior: mistake.id }]
        : without;
    });
  };

  const buildWords = () => {
    const text = sessionAssessment?.text;
    if (!text) return null;

    const parts = text
      .split(/(\s|\.\n|\.\\.\\n|\.\n|\\n|\n|\\n\\n|.\\n\\n|!\\n\\n|؟\\n\\n)/g)
      .filter((part) => part.trim() !== "");

    let wordIdx = -1;

    return parts.map((part, i) => {
      const isDoubleBreak = part.includes("\\n\\n") || part.includes("\n\n");
      const isSingleBreak =
        !isDoubleBreak && (part.includes("\\n") || part.includes("\n"));

      if (isDoubleBreak) {
        return (
          <span key={i}>
            <br />
            <br />
          </span>
        );
      }
      if (isSingleBreak) {
        return <br key={i} />;
      }

      wordIdx++;
      const currentIdx = wordIdx;
      const appliedBehavior = behaviors.find((b) => b.index === currentIdx);
      const mistake = miscueList?.find(
        (m) => m.id === appliedBehavior?.behavior,
      );
      const isActiveWord = dialog.open && dialog.wordIndex === currentIdx;

      return (
        <span
          key={i}
          id={`word-span-${currentIdx}`}
          onClick={() => {
            if (canEdit) {
              handleWordClick(currentIdx, appliedBehavior?.behavior || null);
            }
          }}
          title={mistake?.title || ""}
          className={`session-word ${canEdit ? "clickable" : ""} ${isActiveWord ? "active" : ""} ${mistake ? "has-mistake" : ""}`}
          style={{
            backgroundColor: isActiveWord
              ? "#e2f0d9"
              : mistake?.color || "transparent",
            color: isActiveWord ? "#000000" : mistake ? "#ffffff" : "inherit",
          }}
        >
          {part}
        </span>
      );
    });
  };

  return (
    <>
      {!hideTitle && <h4 className="heading-session">{session?.title}</h4>}

      <div className="session-text-wrap">
        {sessionAssessment?.text && (
          <div className="session-text-words">{buildWords()}</div>
        )}
      </div>

      <SelectMistakePopUp
        editionMode={canEdit}
        open={dialog.open}
        targetId={
          dialog.wordIndex !== null ? `word-span-${dialog.wordIndex}` : null
        }
        onClose={handleCloseDialog}
        onSelect={handleMistakeSelect}
        miscueList={miscueList}
        currentMistakeId={dialog.currentMistakeId}
      />
    </>
  );
};

export default SessionText;
